import React, { FC, PropsWithChildren } from "react";
import type { FooterTranslations } from "@/translations";
import { Link } from "../link";
import Image from "next/image";

interface Props {
  data: FooterTranslations;
}

export const Footer: FC<PropsWithChildren<Props>> = ({ data }) => {
  return (
    <footer className="footer">
      <div className="wrapper">
        <div className="footer--about">
          <Link
            href={data.about.home.link?.uri || "#"}
            aria-label="Home"
            noStyle
            className="footer--logo"
          >
            <Image src="/logo.svg" alt="Logo" width={117} height={38} />
          </Link>
          <div className="footer--address">
            {data.about.address.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  {item} <br />
                </React.Fragment>
              );
            })}
          </div>
          <div className="footer--social">
            <a
              href={data.about.social.twitter.link?.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={data.about.social.twitter.text}
              className="footer--social-link"
            >
              <svg
                viewBox="0 0 16 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.3637 0.27888C14.7227 0.710079 14.0129 1.03988 13.2618 1.25557C12.8586 0.813514 12.3228 0.500195 11.7268 0.35799C11.1308 0.215785 10.5034 0.251555 9.92944 0.460464C9.35547 0.669373 8.86262 1.04134 8.51756 1.52606C8.1725 2.01077 7.99188 2.58485 8.00011 3.17066V3.80902C6.82369 3.83811 5.65799 3.5893 4.60682 3.08476C3.55565 2.58022 2.65165 1.83561 1.97532 0.917241C1.97532 0.917241 -0.702368 6.66249 5.32243 9.21593C3.94377 10.1083 2.30143 10.5558 0.636475 10.4927C6.66127 13.6845 14.0249 10.4927 14.0249 3.1515C14.0243 2.97369 14.0064 2.79632 13.9714 2.62167C14.6546 1.97915 15.1367 1.16793 15.3637 0.27888Z"
                  fill="#020611"
                />
              </svg>
            </a>
            <a
              href={data.about.social.linkedIn.link?.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={data.about.social.linkedIn.text}
              className="footer--social-link"
            >
              <svg
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.71955 4.37598C8.78257 4.37598 9.80205 4.79826 10.5537 5.54993C11.3054 6.3016 11.7277 7.32108 11.7277 8.3841V13.0602H9.05559V8.3841C9.05559 8.02976 8.91483 7.68993 8.66427 7.43938C8.41371 7.18882 8.07389 7.04806 7.71955 7.04806C7.36521 7.04806 7.02538 7.18882 6.77482 7.43938C6.52427 7.68993 6.38351 8.02976 6.38351 8.3841V13.0602H3.71143V8.3841C3.71143 7.32108 4.13371 6.3016 4.88538 5.54993C5.63705 4.79826 6.65653 4.37598 7.71955 4.37598Z"
                  fill="#020611"
                />
                <path
                  d="M2.94796 5.04443H0.275879V13.0607H2.94796V5.04443Z"
                  fill="#020611"
                />
                <path
                  d="M1.61192 3.04025C2.34979 3.04025 2.94796 2.44208 2.94796 1.7042C2.94796 0.96633 2.34979 0.368164 1.61192 0.368164C0.874045 0.368164 0.275879 0.96633 0.275879 1.7042C0.275879 2.44208 0.874045 3.04025 1.61192 3.04025Z"
                  fill="#020611"
                />
              </svg>
            </a>
          </div>
        </div>
        <nav className="footer--nav">
          {data.nav.map((navItem, index) => {
            return navItem.children.length > 0 ? (
              <div key={index} className="footer--linkGroup">
                {navItem.link?.uri ? (
                  <Link
                    href={navItem.link.uri}
                    noStyle
                    className="footer--link"
                  >
                    {navItem.text}
                  </Link>
                ) : (
                  <div className="footer--link">{navItem.text}</div>
                )}

                {navItem.children.map((child, index) => {
                  return (
                    <Link
                      key={index}
                      noStyle
                      href={child.link?.uri || "#"}
                      className="footer--subLink"
                    >
                      {child.text}
                    </Link>
                  );
                })}
              </div>
            ) : (
              <Link
                key={index}
                noStyle
                href={navItem.link?.uri || "#"}
                className="footer--link"
              >
                {navItem.text}
              </Link>
            );
          })}
        </nav>
      </div>
      <div className="footer--copyright">
        © {new Date().getFullYear()} {data.copyright}
      </div>
    </footer>
  );
};
